import axios from "axios";
import store from "../redux/store";
import { showToastAction } from "../redux/toastSlice";

export default async function putExistingObject(projectName, formName, objectId, objectData) {
    try {
        const res = await axios.put(`/project/${projectName}/${formName}/record/${objectId}`, objectData);

        return res.data;
    } catch (err) {
        store.dispatch(showToastAction({
            message: err.response?.data?.errorMessage ?? "Erreur lors de la mise à jour de l'objet",
            showToast: true
        }));
        throw err;
    }
}
